import { useEffect, useState } from "react";

import breakpoints from "../breakpoints";

type ScreenSizeType = {
  isDesktop: boolean;
  isTablet: boolean;
  isPhone: boolean;
  isTabletLandscapeUp: boolean;
};
type ScreenDimensions = { width: number; height: number };

export const useScreenDimensions = (): ScreenDimensions => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  useEffect(() => {
    const listener = (event: Event): void => {
      const w = event.target as Window;
      setDimensions({
        height: w.innerHeight,
        width: w.innerWidth,
      });
    };

    let isThrottled = false;
    const delay = 150;
    const throttledListener = (event: Event): void => {
      if (!isThrottled) {
        isThrottled = true;

        setTimeout(() => {
          listener(event);
          isThrottled = false;
        }, delay);
      }
    };

    window.addEventListener("resize", throttledListener);
    if (window.screen?.orientation) {
      window.screen.orientation.addEventListener("change", listener);
    }

    return () => {
      window.removeEventListener("resize", throttledListener);
      if (window.screen?.orientation) {
        window.screen.orientation?.removeEventListener("change", listener);
      }
    };
  }, []);

  return dimensions;
};

export const useScreenSizeType = (): ScreenSizeType => {
  const dimensions = useScreenDimensions();
  return {
    isDesktop: dimensions.width >= breakpoints.DESKTOP,
    isTablet:
      dimensions.width >= breakpoints.TABLET_PORTRAIT &&
      dimensions.width < breakpoints.DESKTOP,
    isTabletLandscapeUp: dimensions.width >= breakpoints.TABLET_LANDSCAPE,
    isPhone: dimensions.width < breakpoints.TABLET_PORTRAIT,
  };
};
